// set basepath of project for webpack
import { basePath } from './core/config'
__webpack_public_path__ = `${basePath}/assets/frontend/js/`

import 'console-polyfill'
import elementClosestPolyfill from 'element-closest'
elementClosestPolyfill(window)
import 'custom-event-polyfill'
import './polyfills/ElementBefore'
import './polyfills/SVGElement.classList'
import './polyfills/SVGElement.dataset'

// jquery utils
import 'jquery.easing'
import 'corejs-typeahead'

import './plugins/nette.ajax'
import './plugins/nette.ajax.history'
import './plugins/giant.trigger'
import './plugins/giant.autosubmit'
import './plugins/giant.show-if'

// nette
import './nette/NetteValidationMessages'
import './nette/NetteSnippets'
import './nette/NetteLoading'

import Nette from './nette/NetteForms'
window.Nette = Nette
Nette.initOnLoad()

if ($.nette) {
    $.nette.init()
}

try {
    Object.assign({})
} catch(e) {
    console.log(e)
}

import TouchMouseInputResolver from './meta/TouchMouseInputResolver'
new TouchMouseInputResolver()

import components from './components/'
import { loadComponents } from './core/componentUtils'

loadComponents()